import { List } from "antd"
import { t } from "i18next"
import { Icon, SenderReceiver, Tooltip } from "../../common"

const syncIconPopup = (data, width = 150, isShared, sharedData) => {
  return (
    <Tooltip
      trigger="click"
      title={
        <>
          {isShared && (
            <SenderReceiver
              sender={t("Affiliate Shared With")}
              icon="IconDoubleArrowRight"
              receiver={`${sharedData.sharedWith}`}
              date={sharedData?.created}
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            />
          )}
          <List
            size="small"
            dataSource={data || []}
            onClick={e => e.stopPropagation()}
            renderItem={item => {
              return (
                <List.Item>
                  {item[0] === "heading" ? (
                    <strong>{item?.[1]}</strong>
                  ) : (
                    <>
                      <div className="gray-700">{item?.[0]}</div>
                      <div style={{ textAlign: "right", wordBreak: "break-all" }}>{item?.[1]}</div>
                    </>
                  )}
                </List.Item>
              )
            }}
          />
        </>
      }
      overlayInnerStyle={{ width: width }}
    >
      {isShared ? (
        <Icon
          hasBackground
          icon="BsShare"
          color="#707070"
          size="18px"
          style={{ margin: -7, padding: 3 }}
          className="pointer"
          // iconContainerStyle={{ translate: "0 3px" }}
        />
      ) : (
        <Icon
          hasBackground
          icon={"BsInfo"}
          color="#707070"
          size="16px"
          style={{ backgroundColor: "#E6E6E6", borderRadius: "1rem", "--icon-color": "#707070", margin: -8 }}
          className="pointer"
          iconContainerStyle={{ translate: "0 0px" }}
        />
      )}
    </Tooltip>
  )
}

export default syncIconPopup
